// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import { userHeaders } from "../components/HeaderAttribute";
import UserDetails from "../popup-containers/UserDetails";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import InputPassword from "../ReusableComponents/InputPassword";
import UserCapabilityTable from "../components/UserCapabilityTable";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import { useUserCapability } from "../components/ConstantReducerProvider";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";

function UserMaster() {
  const location = useLocation();
  //table Grid Datas State
  const [bindUserMasterDatas, setBindUserMasterDatas] = useState([]);
  const [bindUserEmailPhoneDatas, setBindUserEmailPhoneDatas] = useState([]);

  const [bindUserMastersSDPDatas, setBindUserMastersSDPDatas] = useState([]);
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  //visible States
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [editMode, setEditMode] = useState([]);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [rowIndex, setRowIndex] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  //Value store States
  const [userFields, setUserFields] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    password: "",
    phone: "",
    email: "",
    showImage: "",
    designation: "",
    roleGroup: "",
    state: "",
    location: "",
    country: "",
    sdp: [],
    organizationStructure: "",
  });

  const [userFieldsError, setUserFieldsError] = useState({
    firstNameError: "",
    lastNameError: "",
    passwordError: "",
    emailError: "",
    mobileError: "",
    designationError: "",
    roleGroupError: "",
    stateError: "",
    branchProjectError: "",
    sdpError: "",
    imageUploadedError: "",
    organizationStructureError: "",
  });

  const [designationDropDown, setDesignationDropDown] = useState([]);

  const [roleDropDown, setRoleDropDown] = useState([]);
  const [bindCountry, setBindCountry] = useState([
    { value: "1", label: "India" },
    { value: "2", label: "America" },
    { value: "3", label: "Korea" },
  ]);
  const [stateDropDown, setStateDropDown] = useState([]);
  const [locationDropDown, setLocationDropDown] = useState([]);
  const [sdpDropDown, setSdpDropDown] = useState([]);

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [mstUserId, setMstUserId] = useState("");
  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  const [multiSelectPopupDropDown, setMultiSelectPopupDropDown] = useState([]);
  const [multiSelectSDPPopupDropDown, setMultiSelectSDPPopupDropDown] =
    useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [viewMode, setViewMode] = useState(false);

  //User Capability State data start
  const [bindMenuMasterDatas, setBindMenuMasterDatas] = useState([]);
  const [userBulkUploadData, setUserBulkUploadData] = useState("");
  const [mstRoleId, setMstRoleId] = useState(0);

  //handle edit state

  const [bindLocationDropDown1, setBindLocationDropDown1] = useState([]);
  const [sdpDropDown1, setSdpDropDown1] = useState([]);

  const handleUserFieldsChange = (value, name) => {
    //
    setUserFields({
      ...userFields,
      [name]: value,
    });
  };

  // useEffect(() => {
  //   const getSelectedSDP = async () => {
  //     const locationResponse = await BindAPI("SDPAPI/GetSDP");
  //     setGetSDPDatas(locationResponse.data.Table);
  //   };

  //   getSelectedLocation();
  //   dropDownDatas();
  // }, []);
  useEffect(() => {
    const getDropdownData = async () => {
      dropDownDatas();
      // getSelectedLocation();
    };
    getDropdownData();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //   getUserMasterData();
  // };

  // fetchData();
  // }, []);
  useEffect(() => {
    if (userProfileDatas?.length > 0) {
      getUserMasterData();
    }
  }, [userProfileDatas]);

  const getUserMasterData = async () => {
    try {
      setIsLoading(true);
      const user = userProfileDatas?.[0];
      if (!user) return;

      const data = {
        mstOrganizationStructureId: 1,
        mstBranchId: user.MstLocationId,
        mstSdpId: user.MstSDPId ?? 0,
        mstUserId: user.MstUserId,
        mstRoleId: user.MstRoleId,
      };

      const { data: responseData } = await BindPostAPI(
        data,
        "UserAPI/BindUser"
      );

      setBindUserMasterDatas(responseData?.Table ?? []);
      if (responseData?.Table.length > 0) {
        setVisibleTable(true);
        setVisibleAdd(false);
      } else {
        showAdd();
      }
      setBindUserEmailPhoneDatas(responseData?.Table1 ?? []);
    } catch (error) {
      console.error("Error fetching user master data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const dropDownDatas = async () => {
    try {
      const [
        designationResponse,
        roleResponse,
        statesResponse,
        locationResponse,
      ] = await Promise.all([
        BindAPI("DesignationAPI/GetDesignation"),
        BindAPI("RoleAPI/GetRole"),
        BindAPI("StateAPI/GetState"),
        BindAPI("LocationAPI/GetLocation"),
      ]);

      const designationData =
        designationResponse?.data?.Table?.map((item) => ({
          value: item.MstDesignationId,
          label: item.Designation,
        })) ?? [];

      const roleData = (roleResponse?.data?.Table ?? [])
        .filter((item) => item.InActivatedBy === null)
        .map((item) => ({
          value: item.MstRoleId,
          label: item.RoleName,
        }));

      const statesData =
        statesResponse?.data?.Table?.map((item) => ({
          value: item.MstStateId,
          label: item.StateName_en,
        })) ?? [];

      const locationData =
        locationResponse?.data?.Table?.map((item) => ({
          value: item.MstLocationId,
          label: item.LocationName_en,
        })) ?? [];

      setDesignationDropDown(designationData);
      setRoleDropDown(roleData);
      setStateDropDown(statesData);
      setLocationDropDown(locationData);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  // const getSelectedLocation = async () => {
  //   const locationResponse = await BindAPI("LocationAPI/GetLocation");
  //   setGetLocationDatas(locationResponse.data.Table);
  // };

  // useEffect(() => {
  //   // Find the selected state in getLocationDatas
  //   const stateSelectedValue = getLocationDatas.find(
  //     (item) => item.MstStateId == userFields.state // Replace with the desired MstStateId
  //   );

  //   if (stateSelectedValue) {
  //     const locationLabels = getLocationDatas
  //       .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
  //       .map((item) => ({
  //         MstLocationId: item.MstLocationId,
  //         LocationName_en: item.LocationName_en,
  //       }));

  //     const locationSelected = locationLabels.map((LC) => ({
  //       value: LC.MstLocationId, // Replace with the appropriate value
  //       label: LC.LocationName_en,
  //     }));
  //     setBindLocationDropDown1(locationSelected);
  //   } else {
  //   }
  // }, [userFields.state ? userFields.state : null]);

  useEffect(() => {
    const SDPSelectedValue = getSDPDatas.find(
      (item) => item.MstLocationId == userFields.location // Replace with the desired MstStateId
    );

    if (SDPSelectedValue) {
      const sdpLabels = getSDPDatas
        .filter((item) => item.MstLocationId === SDPSelectedValue.MstLocationId)
        .map((item) => ({ MstSDPId: item.MstSDPId, SDP_en: item.SDP_en }));

      const sdpSelected = sdpLabels.map((SD) => ({
        value: SD.MstSDPId, // Replace with the appropriate value
        label: SD.SDP_en,
      }));
      setSdpDropDown1(sdpSelected);
    } else {
    }
  }, [userFields.location]);

  useEffect(() => {
    if (userFields.location && viewMode) {
      const SDPSelectedValue = getSDPDatas.find(
        (item) => item.MstLocationId == userFields.location
      );

      if (SDPSelectedValue) {
        const sdpLabels = getSDPDatas
          .filter(
            (item) => item.MstLocationId == SDPSelectedValue.MstLocationId
          )
          .map((item) => ({ MstSDPId: item.MstSDPId, SDP_en: item.SDP_en }));

        setMultiSelectPopupDropDown(sdpLabels);
      } else {
      }
    }
  }, [userFields.location, viewMode]);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setEditMode(null);
    setUserFields({
      firstName: "",
      middleName: "",
      lastName: "",
      password: "",
      phone: "",
      email: "",
      showImage: "",
      designation: "",
      roleGroup: "",
      state: "",
      location: "",
      country: "",
      organizationStructure: "",
    });
    localStorage.setItem("screenMode", "add");
  };

  const cancel = async () => {
    //call table Grid data
    getUserMasterData();

    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);

    //Clear User data
    setUserFields({
      firstName: "",
      middleName: "",
      lastName: "",
      password: "",
      phone: "",
      email: "",
      showImage: "",
      designation: "",
      roleGroup: "",
      state: "",
      location: "",
      country: "",
      organizationStructure: "",
    });

    //clear Error
    setUserFieldsError({
      firstNameError: "",
      lastNameError: "",
      passwordError: "",
      emailError: "",
      mobileError: "",
      designationError: "",
      roleGroupError: "",
      stateError: "",
      branchProjectError: "",
      sdpError: "",
      imageUploadedError: "",
      organizationStructureError: "",
    });

    //clear popup
    setpopUpOpen(false);

    //clear dropdown datas
    setSdpDropDown1([]);

    setSelectedRowIndex(null);
    setEditMode(null);
    setViewMode(null);
    setMultiSelectSDPPopupDropDown([]);
    setMultiSelectPopupDropDown([]);
    setIsLoading(false);
    localStorage.setItem("screenMode", "");
  };
  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);

    const data = bindUserMasterDatas[rowIndex]; // safety
    if (!data) return;
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    const getUserSDPDatas = Object.values(bindUserMastersSDPDatas).filter(
      (item) => item.MstUserId === bindUserMasterDatas[rowIndex].MstUserId
    );

    const sdps = getUserSDPDatas.map((item) => item.MstSDPId);
    setUserFields({
      ...userFields,
      firstName: bindUserMasterDatas[rowIndex].FirstName,
      middleName: bindUserMasterDatas[rowIndex].MiddleName,
      password: "",
      lastName: bindUserMasterDatas[rowIndex].LastName,
      email: bindUserMasterDatas[rowIndex].UserEmail,
      phone: bindUserMasterDatas[rowIndex].UserMobile,
      showImage: bindUserMasterDatas[rowIndex].UserProfileImg,
      designation: bindUserMasterDatas[rowIndex].Designation,
      roleGroup: bindUserMasterDatas[rowIndex].MstRoleId,
      state: bindUserMasterDatas[rowIndex].State == "-" ? null : bindUserMasterDatas[rowIndex].State,
      location: bindUserMasterDatas[rowIndex].Location== "-" ? null : bindUserMasterDatas[rowIndex].Location,
      organizationStructure: bindUserMasterDatas[rowIndex].MstOrganizationId,
      sdp: sdps,
    });

    setMstUserId(bindUserMasterDatas[rowIndex].MstUserId);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex); // store index
  };
  //   useEffect(() => {
  //     if (location.pathname === "/usermaster") {
  //       const screenMode = localStorage.getItem("screenMode");
  //
  //       if (screenMode === "add") {
  //         showAdd();
  //         // setVisibleAdd(true);
  //         // setVisibleTable(false);
  //         // setAddScreenTitle(true);
  //         // setUpdateScreenTitle(false);
  //         // setUserFields({
  //         //   firstName: "",
  //         //   middleName: "",
  //         //   lastName: "",
  //         //   password: "",
  //         //   phone: "",
  //         //   email: "",
  //         //   showImage: "",
  //         //   designation: "",
  //         //   roleGroup: "",
  //         //   state: "",
  //         //   location: "",
  //         //   country: "",
  //         //   sdp: [],
  //         //   organizationStructure: "",
  //         // });
  //       } else if (screenMode === "edit") {
  //
  //         const storedIndex = localStorage.getItem("selectedRowIndex");
  //         if (storedIndex !== null && bindUserMasterDatas.length > 0) {
  //           handleEdit(Number(storedIndex));
  //         }
  //       }
  //      // else{cancel();}
  //     }
  //   }, [location, bindUserMasterDatas]);

  useEffect(() => {
    if (location.pathname === "/usermaster") {
      const screenMode = localStorage.getItem("screenMode");

      if (screenMode === "add") {
        showAdd();
      }
    }
  }, [location]);

  useEffect(() => {
    const screenMode = localStorage.getItem("screenMode");
    const storedIndex = localStorage.getItem("selectedRowIndex");

    if (screenMode === "edit" && storedIndex !== null) {
      if (bindUserMasterDatas.length > 0) {
        handleEdit(Number(storedIndex));
      } else localStorage.setItem("screenMode", "edit");
    }
  }, [bindUserMasterDatas]);

  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      // Validation logic for the userFields.firstName input
      if (!userFields.firstName) {
        errors.firstName = "Enter First Name";
      }
      //  else if (!/^[A-Za-z ]+$/.test(userFields.firstName.trim())) {
      //   errors.firstName = "Only alphabet and space allowed";
      // }

      // Validation logic for the lastName input
      if (!userFields.lastName.trim()) {
        errors.lastName = "Enter Last Name";
      } 
      // else if (!/^[A-Za-z ]+$/.test(userFields.lastName.trim())) {
      //   errors.lastName = "Only alphabet and space allowed";
      // }

      // Validation logic for the email input
      if (!userFields.email.trim()) {
        errors.email = "Enter Email";
      } 
      // else if (
      //   !/^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(
      //     userFields.email
      //   )
      // ) {
      //   errors.email = "Enter a valid Email Address";
      // } 
      else if (
        !updateScreenTitle &&
        bindUserEmailPhoneDatas.find(
          (x) => x.UserEmail.toLowerCase() === userFields.email.toLowerCase()
        )
      ) {
        errors.email = "Email Address already available";
      }

      // Validation logic for the phone input
      if (!userFields.phone.trim()) {
        errors.phone = "Enter Mobile Number";
      }
      // else if (!/^(\+91[\s\-]?)?[6-9]\d{9}$/.test(userFields.phone.trim())) {
      //   errors.phone = "Enter a valid Mobile Number starting with 6-9";
      // }
      else if (
        !updateScreenTitle &&
        bindUserEmailPhoneDatas.find(
          (x) =>
            x.UserMobile.toLowerCase() === userFields.phone.trim().toLowerCase()
        )
      ) {
        errors.phone = "Mobile Number already available";
      }
      const trimmedDesignation = userFields.designation?.trim() || "";
      const trimmedState = userFields.state?.trim() || "";
      const trimmedCity = userFields.location?.trim() || "";
      // Validation logic for the designation input
      if (trimmedDesignation == "") {
        errors.designation = "Enter Designation";
      } 
      // else if (
      //   trimmedDesignation == /^[A-Za-z ]+$/.test(trimmedDesignation)
      // ) {
      //   errors.designation = "Only Alphabet and space allowed";
      // }
     

      // Validation logic for the role group input
      if (userFields.roleGroup == "") {
        errors.roleGroup = "Select Role";
      }

      // State validation
// if (trimmedState !== "" && !/^[A-Za-z ]+$/.test(trimmedState)) {
//   errors.state = "Only alphabets and spaces allowed";
// }
if (trimmedState == "") {
  errors.state = "Enter State";
}

// City (location) validation
if (trimmedCity == "") {
  errors.location = "Enter City";
}

      if (userFields.password === "") {
        errors.password = "Enter Password";
      } else if (userFields.password.length < 8) {
        errors.password = "Password must be at least 8 characters";
      } else if (userFields.password.length > 30) {
        errors.password = "Password must not exceed 30 characters";
      } else {
        const passwordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,30}$/;
        if (!passwordRegex.test(userFields.password)) {
          errors.password =
            "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character";
        }
      }
    }

    setUserFieldsError({
      ...userFieldsError,
      firstNameError: errors.firstName || "",
      lastNameError: errors.lastName || "",
      passwordError: errors.password || "",
      emailError: errors.email || "",
      mobileError: errors.phone || "",
      designationError: errors.designation || "",
      roleGroupError: errors.roleGroup || "",
      stateError: errors.state || "",
      branchProjectError: errors.location || "",
      sdpError: errors.sdp || "",
    });

    return errors; // Return the errors object containing validation errors (if any)
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);

    const firstNameValidation = validate(flag);
    if (Object.keys(firstNameValidation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(firstNameValidation).length === 0) {
      setIsOpen(false);
      var createdBy = sessionStorage.getItem("createdBy");
      setIsLoading(true);
      if (flag == 1) {
        const userPayload = [
          {
            firstName: userFields.firstName,

            middleName: userFields.middleName,

            lastName: userFields.lastName,

            userEmail: userFields.email,
            userMobile: userFields.phone,
            Designation: userFields.designation,
            mstRoleId: userFields.roleGroup,
            mstOrganizationId: parseInt(userFields.organizationStructure),
            mstCountryId: 1,
            State: userFields.state ? userFields.state : null,
            Location: userFields.location ? userFields.location : null,
            mstSDPId: userFields.sdp
              ? JSON.stringify(userFields.sdp).slice(1, -1)
              : "",
            userProfileImg:
              userFields.showImage == "" ? null : userFields.showImage,
            userPassword: userFields.password,
            createdBy: createdBy,
            bulkUpload: userBulkUploadData,
            flag: flag,
          },
        ];

        const response = await IUDAPI(userPayload, "UserAPI/IUDUser");
        if (response.data.Table1[0].Result === "S") {
          toast.success("User added successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error(
            " User add failed. Please review the details and try again. 👎",
            {
              duration: 2000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 2000);
        }
      } else if (flag == 2) {
        const userPayload = [
          {
            mstUserId: mstUserId,
            firstName: userFields.firstName,
            middleName: userFields.middleName,
            lastName: userFields.lastName,
            userEmail: userFields.email,
            userMobile: userFields.phone,
            Designation: userFields.designation,
            mstRoleId: userFields.roleGroup,
            mstOrganizationId: parseInt(userFields.organizationStructure),
            mstCountryId: 1,
            State: userFields.state,
            Location: userFields.location,
            mstSDPId: JSON.stringify(
              userFields.sdp ? userFields.sdp : "0"
            ).slice(1, -1),
            userProfileImg: userFields.showImage,
            userPassword: userFields.password,
            createdBy: createdBy,
            bulkUpload: userBulkUploadData,
            flag: flag,
          },
        ];
        const response = await IUDAPI(userPayload, "UserAPI/IUDUser");

        if (response.data.Table1[0].Result === "M") {
          toast.success("Modified complete! 👍", {
            duration: 4000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error(
            "  User modify failed. Please double-check the information and try again. 👎",
            {
              duration: 2000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 2000);
        }
      } else if (flag == 3 || flag == 4 || flag == 5) {
        const userPayload = [
          {
            mstUserId: bindUserMasterDatas[items].MstUserId,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(userPayload, "UserAPI/IUDUser");
        
        if (flag == 3) {
          if (response.data.Table1[0].Result === "D") {
            toast.success("Deleted successfully 🗑️", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("failed!", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 4) {
          if (response.data.Table1[0].Result === "B") {
            toast.success("User Inactivated successfully!. 🔒", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("failed!", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 5) {
          if (response.data.Table1[0].Result === "UB") {
            toast.success("User activated successfully! 🔓", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("failed!", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        return false;
      }
    } else {
      setSubmitBtnDisabled(false);
    }
  };

  const handleUserDetails = (rowIndex, flag) => {
    setpopUpOpen(true);
    setViewMode(true);
    // setLocation(bindUserMasterDatas[rowIndex].MstLocationId);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
      setRowIndex(rowIndex);
    }
    setCurrentData(bindUserMasterDatas[rowIndex]);
    setUserFields({
      ...userFields,
      location: bindUserMasterDatas[rowIndex].MstLocationId,
    });
    //Designation DropDown Value Start
    const userData = bindUserMasterDatas[rowIndex];
    const userDesignationDropDownValue = designationDropDown.find(
      (item) => item.value === userData.MstDesignationId
    );

    const editDesignationDropDownValue = {
      value: userData.MstDesignationId,
      label: userDesignationDropDownValue
        ? userDesignationDropDownValue.label
        : "Unknown",
    };
    //Designation DropDown Value end

    //RoleGroup DropDown Value Start

    const userRoleGroupDropDownValue = roleDropDown.find(
      (item) => item.value === userData.MstRoleId
    );

    const editUserRoleDropDownValue = {
      value: userData.MstRoleId,
      label: userRoleGroupDropDownValue
        ? userRoleGroupDropDownValue.label
        : "Unknown",
    };

    //RoleGroup DropDown Value End;

    //State DropDown Value Start

    const userStateDropDownValue = stateDropDown.find(
      (item) => item.value === userData.MstStateId
    );
    const editUserStateDropDownValue = {
      value: userData.MstStateId,
      label: userStateDropDownValue ? userStateDropDownValue.label : "Unknown",
    };

    //State DropDown Value End

    //Location DropDown Start

    const userLocationDropDownValue = locationDropDown.find(
      (item) => item.value === userData.MstLocationId
    );

    const editUserLocationDropDownvalue = {
      value: userData.MstLocationId,
      label: userLocationDropDownValue
        ? userLocationDropDownValue.label
        : "Unknown",
    };

    //Location DropDown End

    //sdp dropdown start

    const getUserSDPDatas = Object.values(bindUserMastersSDPDatas).filter(
      (item) => item.MstUserId === bindUserMasterDatas[rowIndex].MstUserId
    );

    const sdps = getUserSDPDatas.map((item) => item.MstSDPId);

    const autoDropDownValues = [
      editDesignationDropDownValue,
      editUserRoleDropDownValue,
      editUserStateDropDownValue,
      editUserLocationDropDownvalue,
      sdps,
      //bindUserMasterDatas[rowIndex].MstSDPId,
      // editUserAreaDropDownValue,
    ];
    setPopUpDropDownData(autoDropDownValues);
  };

  useEffect(() => {
    const getMenuTableDatas = async () => {
      let rightsResponse;
      try {
        if (
          editMode &&
          userFields.roleGroup ==
            bindUserMasterDatas[selectedRowIndex].MstRoleId
        ) {
          rightsResponse = await IUDAPI(
            {
              mstUserId: mstUserId,
              mstRoleId: bindUserMasterDatas[selectedRowIndex].MstRoleId,
            },
            "UserAPI/GetUserCapability"
          );
        } else {
          rightsResponse = await BindAPI(
            "RoleVsCapabilityAPI/BindRoleVsCapability"
          );
        }
        const response = await BindAPI("RoleVsCapabilityAPI/BindScreenMenu");
        const organizedData = {};

        const processMenuData = (menuHeadingId) => {
          const filteredData = response.data.Table.filter(
            (item) => item.MstMenuHeadingId === menuHeadingId
          );

          const menuList = {};

          filteredData.forEach((item) => {
            if (!menuList[item.MenuName]) {
              menuList[item.MenuName] = {
                MenuName: item.MenuName,
                MstMenuId: item.MainMenuId ? null : item.MstMenuId,
                MainMenuId: item.MainMenuId,
                MstMenuHeadingId: item.MstMenuHeadingId,
                checked:
                  item.MainMenuId && item.SubMenu && item.SubMenu.length > 0
                    ? null
                    : [],
                SubMenu: [],
                View: item.View,
                Add: item.Add,
                Edit: item.Edit,
                Delete: item.Delete,
                Inactive: item.Inactive,
                Service: item.Service,
              };
            }

            const submenuFiltered = response.data.Table.filter(
              (subItem) =>
                subItem.MenuName === item.MenuName &&
                subItem.MainMenuId &&
                subItem.MstMenuHeadingId === menuHeadingId
            ).map((subItem) => ({
              SubMenu: subItem.SubMenu,
              MstMenuId: subItem.MstMenuId,
              MainMenuId: subItem.MainMenuId,
              MstMenuHeadingId: subItem.MstMenuHeadingId,
              checked: [],
              View: item.View,
              Add: item.Add,
              Edit: item.Edit,
              Delete: item.Delete,
              Inactive: item.Inactive,
              Service: item.Service,
            }));

            const arr = rightsResponse.data.Table.filter(
              (e) =>
                e.MstMenuId == menuList[item.MenuName].MstMenuId &&
                e.MstRoleId == userFields.roleGroup
            );
            const checkedData =
              arr.length > 0
                ? {
                    add: arr[0].AddPermission === 1,
                    view: arr[0].ViewPermission === 1,
                    inActive: arr[0].BlockPermission === 1,
                    delete: arr[0].DeletePermission === 1,
                    edit: arr[0].ModifyPermission === 1,
                    service: arr[0].ProvideServicePermission === 1,
                    title:
                      arr[0].AddPermission === 1 &&
                      arr[0].ViewPermission === 1 &&
                      arr[0].BlockPermission === 1 &&
                      arr[0].DeletePermission === 1 &&
                      arr[0].ModifyPermission === 1 &&
                      arr[0].ProvideServicePermission === 1,
                  }
                : {
                    title: false,
                    add: false,
                    view: false,
                    inActive: false,
                    delete: false,
                    edit: false,
                    service: false,
                  };
            if (menuList[item.MenuName].checked !== null) {
              menuList[item.MenuName].checked.push(checkedData);
            }

            submenuFiltered.forEach((subItem) => {
              const subMenuItemExists = menuList[item.MenuName].SubMenu.some(
                (existingSubMenu) => existingSubMenu.SubMenu == subItem.SubMenu
              );
              if (!subMenuItemExists) {
                const arr = rightsResponse.data.Table.filter(
                  (e) =>
                    e.MstMenuId == subItem.MstMenuId &&
                    e.MstRoleId == userFields.roleGroup
                );
                subItem.checked =
                  arr.length > 0
                    ? {
                        add: arr[0].AddPermission === 1,
                        view: arr[0].ViewPermission === 1,
                        inActive: arr[0].BlockPermission === 1,
                        delete: arr[0].DeletePermission === 1,
                        edit: arr[0].ModifyPermission === 1,
                        service: arr[0].ProvideServicePermission === 1,
                        title:
                          arr[0].AddPermission === 1 &&
                          arr[0].ViewPermission === 1 &&
                          arr[0].BlockPermission === 1 &&
                          arr[0].DeletePermission === 1 &&
                          arr[0].ModifyPermission === 1 &&
                          arr[0].ProvideServicePermission === 1,
                      }
                    : {
                        title: false,
                        add: false,
                        view: false,
                        inActive: false,
                        delete: false,
                        edit: false,
                        service: false,
                      };

                if (!subMenuItemExists) {
                  menuList[item.MenuName].SubMenu.push(subItem);
                }
              }
            });
          });

          return Object.values(menuList);
        };

        organizedData.Dashboard = processMenuData(1); // Dashboard
        organizedData.Administrator = processMenuData(2); // Administrator
        organizedData.Analyst = processMenuData(3); // Transaction
        organizedData.Partner = processMenuData(4); // Reports
        organizedData.Reviewer = processMenuData(5); // Reports

        setBindMenuMasterDatas(organizedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getMenuTableDatas();
  }, [
    editMode ? editMode : null,
    userFields.roleGroup ? userFields.roleGroup : null,
    mstUserId ? mstUserId : null,
    mstRoleId ? mstRoleId : null,
  ]);

  //Main code

  const handleUserCapabilityData = (userData) => {
    const convertJSONString = JSON.stringify(userData);
    setUserBulkUploadData(convertJSONString);
  };

  const handleShowImage = (showImage) => {
    setUserFields({
      ...userFields,
      showImage: showImage,
    });
    setUserFieldsError({ ...userFieldsError, imageUploadedError: "" });
  };
 
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading && (
        <GridPage
          title="User Master"
          header={userHeaders}
          records={bindUserMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleUserDetails}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="User"
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className={mainTable.grid3}>
                    <div>
                      <InputText
                        inputType="text"
                        classStar={"text-red-500"}
                        title="First Name"
                        name="firstName"
                        maxLength={50}
                        content={userFields.firstName}
                        controlFunc={(e) =>
                          setUserFields({
                            ...userFields,
                            firstName: e.target.value,
                          })
                        }
                        controlFuncBlur={() => {
                          setUserFieldsError((userFieldsError) => ({
                            ...userFieldsError,
                            firstNameError:
                              userFields.firstName &&
                              userFields.firstName.length > 0
                                // ? /^[A-Za-z ]+$/.test(userFields.firstName)
                                  ? ""
                                  // : "Only Alphabet and space allowed"
                                : "Enter First Name",
                          }));
                        }}
                        errorMessage={userFieldsError.firstNameError}
                      />
                    </div>

                    <InputText
                      inputType="text"
                      title="Middle Name"
                      name="middleName"
                      maxLength={50}
                      content={userFields.middleName}
                      controlFunc={(e) =>
                        setUserFields({
                          ...userFields,
                          middleName: e.target.value,
                        })
                      }
                    />
                    <div>
                      <InputText
                        inputType="text"
                        classStar={"text-red-500"}
                        title="Last Name"
                        name="lastName"
                        maxLength={50}
                        content={userFields.lastName}
                        controlFunc={(e) =>
                          setUserFields({
                            ...userFields,
                            lastName: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setUserFieldsError((userFieldsError) => ({
                            ...userFieldsError,
                            lastNameError:
                              userFields.lastName &&
                              userFields.lastName.length > 0
                                // ? /^[A-Za-z ]+$/.test(userFields.lastName)
                                  ? ""
                                  // : "Only Alphabet and space allowed"
                                : "Enter Last Name",
                          }));
                        }}
                        errorMessage={userFieldsError.lastNameError}
                      />
                    </div>
                    <div>
                      <InputPassword
                        inputType="password"
                        classStar={"text-red-500"}
                        title="Password"
                        name="password"
                        placeholder="XXXXXXXXXX"
                        maxLength={12}
                        content={userFields.password}
                        controlFunc={(e) =>
                          setUserFields({
                            ...userFields,
                            password: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          const password = userFields.password;
                          const passwordRegex =
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,30}$/;

                          setUserFieldsError((userFieldsError) => ({
                            ...userFieldsError,
                            passwordError: !password
                              ? "Enter Password"
                              : password.length < 8
                              ? "Password must be at least 8 characters"
                              : password.length > 30
                              ? "Password must not exceed 30 characters"
                              : !passwordRegex.test(password)
                              ? "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character"
                              : "",
                          }));
                        }}
                        errorMessage={userFieldsError.passwordError}
                      />
                    </div>
                    <div>
                      <InputText
                        inputType="email"
                        classStar={"text-red-500"}
                        title="Email"
                        name="email"
                        placeholder=""
                        maxLength={150}
                        // disabled={editMode ? editMode : false}
                        content={userFields.email}
                        controlFunc={(e) =>
                          setUserFields({
                            ...userFields,
                            email: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setUserFieldsError((userFieldsError) => ({
                            ...userFieldsError,
                            emailError:
                              userFields.email && userFields.email.length > 0
                                // ? /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z.]{2,4}$/.test(
                                //     userFields.email
                                //   )
                                  ? !updateScreenTitle &&
                                    bindUserEmailPhoneDatas.find(
                                      (x) =>
                                        x.UserEmail.toLowerCase() ==
                                        userFields.email.toLowerCase()
                                    )
                                    ? "Email address already available"
                                    : ""
                                  // : "Enter a valid email address "
                                : "Enter Email",
                          }));
                        }}
                        errorMessage={userFieldsError.emailError}
                      />
                    </div>
                    <div>
                      <InputText
                        inputType="text"
                        classStar={"text-red-500"}
                        title="Mobile Number"
                        name="phone"
                        placeholder=""
                        maxLength={20}
                        content={userFields.phone}
                        controlFunc={(e) =>
                          setUserFields({
                            ...userFields,
                            phone: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          const phone = userFields.phone.trim();

                          setUserFieldsError((userFieldsError) => ({
                            ...userFieldsError,
                            mobileError:
                              phone && phone.length > 0
                                 // ? /^(\+91[\s\-]?)?[6-9]\d{9}$/.test(phone)
                                 ? !updateScreenTitle &&
                                  bindUserEmailPhoneDatas.find(
                                    (x) =>
                                      x.UserMobile.toLowerCase() ===
                                      phone.toLowerCase()
                                  )
                                  ? "Mobile Number already available"
                                  : ""
                                : // : "Enter a valid Mobile Number starting with 6-9"
                                  "Enter Mobile Number",
                          }));
                        }}
                        errorMessage={userFieldsError.mobileError}
                      />
                    </div>
                    <InputText
                      inputType="text"
                      classStar={"text-red-500"}
                      title="Designation"
                      name="designation"
                      maxLength={50}
                      content={userFields.designation}
                      controlFunc={(e) =>
                        setUserFields({
                          ...userFields,
                          designation: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        const trimmedDesignation =
                          userFields.designation?.trim() || "";

                        setUserFieldsError((userFieldsError) => ({
                          ...userFieldsError,
                          designationError:
                            trimmedDesignation && trimmedDesignation.length > 0
                              // ? /^[A-Za-z ]+$/.test(trimmedDesignation)
                                ? ""
                                // : "Only Alphabet and space allowed"
                              : "Enter Designation",
                        }));
                      }}
                      errorMessage={userFieldsError.designationError}
                    />
                    {/* <div>
                      <AutoDropDown
                        title="Designation"
                        classStar={"text-red-500"}
                        options={designationDropDown}
                        placeholder={"Select"}
                        name="designation"
                        selectedOption={designationDropDown.find(
                          (x) => x.value == userFields.designation
                        )}
                        controlFunc={(value, e) => {
                          handleUserFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setUserFieldsError(() => ({
                            ...userFieldsError,
                            designationError: userFields.designation
                              ? ""
                              : "Select Designation",
                          }));
                        }}
                        Class="custom-class"
                        tabIndex="1"
                        errorMessage={userFieldsError.designationError}
                      />
                    </div> */}
                    <div>
                      <AutoDropDown
                        title="Role"
                        classStar={"text-red-500"}
                        options={addScreenTitle
      ? roleDropDown.filter((x) => x.value !== 3)
      : roleDropDown}
                        placeholder="Select"
                        name="roleGroup"
                        selectedOption={roleDropDown.find(
                          (x) => x.value == userFields.roleGroup
                        )}
                        controlFunc={(value, e) => {
                          handleUserFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setUserFieldsError({
                            ...userFieldsError,
                            roleGroupError: userFields.roleGroup
                              ? ""
                              : "Select Role/Groups",
                          });
                        }}
                        errorMessage={userFieldsError.roleGroupError}
                        Class="custom-class"
                        tabIndex="1"
                      />
                    </div>
                    <DropDown
                      classDiv="hidden"
                      title="Country"
                      options={bindCountry}
                      placeholder="Select"
                      name="country"
                      selectedOption={userFields.country}
                      controlFunc={(value, e) => {
                        handleUserFieldsChange(value, e);
                      }}
                    />
                    <InputText
                      inputType="text"
                      // classStar={"text-red-500"}
                      title="State"
                      name="state"
                      maxLength={50}
                      content={userFields.state}
                      controlFunc={(e) =>
                        setUserFields({
                          ...userFields,
                          state: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        const value = userFields.state?.trim() || "";

                        // If value is empty, don't validate or show error
                        if (value === "") {
                          setUserFieldsError((UserFieldsError) => ({
                            ...UserFieldsError,
                            stateError: "",
                          }));
                          return;
                        }

                        // // Validate only alphabets and spaces
                        // const isValid = /^[A-Za-z ]+$/.test(value);

                        // setUserFieldsError((UserFieldsError) => ({
                        //   ...UserFieldsError,
                        //   stateError: isValid
                        //     ? ""
                        //     : "Only alphabets and spaces allowed",
                        // }));
                      }}
                      // controlFuncBlur={(e) => {
                      //   const trimmedState = userFields.state?.trim() || "";
                      //   setUserFieldsError((userFieldsError) => ({
                      //     ...userFieldsError,
                      //     stateError:
                      //       trimmedState && trimmedState.length > 0
                      //         ? /^[A-Za-z ]+$/.test(trimmedState)
                      //           ? ""
                      //           : "Only Alphabet and space allowed"
                      //         : "Enter State",
                      //   }));
                      // }}
                      errorMessage={userFieldsError.stateError}
                    />
                    {/* <AutoDropDown
                      title="State"
                      classStar={"text-red-500"}
                      options={stateDropDown}
                      placeholder="Select"
                      name="state"
                      selectedOption={stateDropDown.find(
                        (x) => x.value == userFields.state
                      )}
                      controlFunc={(value, e) => {
                        handleUserFieldsChange(value.value, e.name);
                        setUserFields({
                          ...userFields,
                          state: value.value,
                          location: "",
                          sdp: "",
                        });
                      }}
                      controlFuncBlur={() => {
                        setUserFieldsError({
                          ...userFieldsError,
                          stateError: userFields.state ? "" : "Select State",
                        });
                      }}
                      Class="custom-class"
                      tabIndex="1"
                      errorMessage={userFieldsError.stateError}
                    /> */}

                    <InputText
                      inputType="text"
                      // classStar={"text-red-500"}
                      title="City"
                      name="city"
                      maxLength={50}
                      content={userFields.location}
                      controlFunc={(e) =>
                        setUserFields({
                          ...userFields,
                          location: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        const value = userFields.location?.trim() || "";

                        // If value is empty, don't validate or show error
                        if (value === "") {
                          setUserFieldsError((userFieldsError) => ({
                            ...userFieldsError,
                            branchProjectError: "",
                          }));
                          return;
                        }

                        // // Validate only alphabets and spaces
                        // const isValid = /^[A-Za-z ]+$/.test(value);

                        // setUserFieldsError((userFieldsError) => ({
                        //   ...userFieldsError,
                        //   branchProjectError: isValid
                        //     ? ""
                        //     : "Only alphabets and spaces allowed",
                        // }));
                      }}
                      // controlFuncBlur={(e) => {
                      //   const trimmedCity = userFields.location?.trim() || "";
                      //   setUserFieldsError((userFieldsError) => ({
                      //     ...userFieldsError,
                      //     branchProjectError:
                      //       trimmedCity && trimmedCity.length > 0
                      //         ? /^[A-Za-z ]+$/.test(trimmedCity)
                      //           ? ""
                      //           : "Only Alphabet and space allowed"
                      //         : "Enter City",
                      //   }));
                      // }}
                      errorMessage={userFieldsError.branchProjectError}
                    />
                    {/* <AutoDropDown
                      title="City"
                      classStar={"text-red-500"}
                      options={locationDropDown && bindLocationDropDown1}
                      placeholder="Select"
                      name="location"
                      selectedOption={
                        userFields.location
                          ? locationDropDown.find(
                              (x) => x.value == userFields.location
                            )
                          : ""
                      }
                      controlFunc={(value, e) => {
                        handleUserFieldsChange(value.value, e.name);
                        setUserFields({
                          ...userFields,
                          location: value.value,
                          sdp: [],
                        });
                      }}
                      controlFuncBlur={() => {
                        setUserFieldsError({
                          ...userFieldsError,
                          branchProjectError: userFields.location
                            ? ""
                            : "Select City",
                        });
                      }}
                      Class="custom-class"
                      tabIndex="1"
                      errorMessage={userFieldsError.branchProjectError}
                    /> */}
                  </div>

                  <FileUpload
                    title="File Upload"
                    apiCall="UserAPI/UserImageUpload"
                    modalName="UserImage"
                    showImage={userFields.showImage}
                    disabledBtn={updateScreenTitle}
                    showImageData={handleShowImage}
                    imageUploadedError={userFieldsError.imageUploadedError}
                    limitMassage={
                      "Image size limit: 1 MB. Accepted Image types: jpg, png, jpeg. Please Upload The Image After Choosing It."
                    }
                    MAX_FILE_SIZE_MB={1}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  />
                  <div class="w-full">
                    <UserCapabilityTable
                      menuData={bindMenuMasterDatas}
                      handleChange={
                        setBindMenuMasterDatas.length > 0
                          ? setBindMenuMasterDatas
                          : setBindMenuMasterDatas
                      }
                      handleRoleChange={userFields.roleGroup}
                      handleUserCapability={handleUserCapabilityData}
                    />
                  </div>
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="User"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <UserDetails
            data={currentData}
            data2={popUpDropDownData}
            data3={multiSelectPopupDropDown}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
}

export default UserMaster;
